export default "__VITE_ASSET__82d19d3d__"